import { blocks } from '@yola/ws-sdk';

const isElementWidget = (element) =>
  !!element && blocks.verifiers.isElementBlock(element) && element.hasAttribute('widget');

export default isElementWidget;
